import React from "react";
import ReactDOM from "react-dom";
import { Provider } from 'react-redux';
import { I18nextProvider } from "react-i18next";
import * as serviceWorker from './serviceWorker';
import App from "./App.jsx";
import i18n from './utils/localizations.jsx';
import { configureStore } from "./state/store";

const store = configureStore();

ReactDOM.render(
    <Provider store={store}>
        <I18nextProvider i18n={i18n}>
                <App />
        </I18nextProvider>
    </Provider>,
    document.getElementById('app')
)

serviceWorker.unregister();